// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"5efdafce","96":"c11ba2b8","214":"76b6e538","290":"819cd287","408":"7abe3905","686":"c8c80346"}[chunkId] + ".chunk.js";
};